import { HelpCenterUrls } from 'app/utils/help-center';

export const getInviteText = (name: string, roomUri: string, ownRoom = true): string => {
  const helpLink = HelpCenterUrls.HELP_CENTER;
  const intro = ownRoom
    ? `You’ve been invited to a Scoot room hosted by ${name}.`
    : `Below is your Scoot Social link to the room hosted by ${name}.`;
  return `${intro}
    \nPaste this link into your browser.
    \n${roomUri}
    \nSupported browsers include:
      • The latest Chrome web browser (version 87.0.4280.88 or higher)
      • The latest Edge web browser (version 87.0.664.60 or higher)
      • The latest Safari web browser (version 14.1.1 or higher)
      • The latest Firefox web browser (version 90.0 or higher)
    \nScoot works on Android tablets and phones using the Google Chrome app.
    \nGet the Scoot app for iOS https://apps.apple.com/us/app/scoot-app/id1568145097
    \nBe sure you have a hi-speed internet connection and a high speed processor.
    \nIf you have additional questions, visit our Help Center ${helpLink}`;
};

export const DEVICE_NOT_SUPPORTED_TITLE = 'Browser or Device Not Supported';
export const DEVICE_NOT_SUPPORTED_TEXT =
  'Scoot does not support your browser or device. Please login on a desktop/laptop computer using the latest version of Chrome (version 87.0.4280.88 or higher), Edge (version 87.0.664.60 or higher), Firefox (version 119.0.1 or higher) or Safari (version 5.1.10 or higher)';
export const GET_IOS_APP_TEXT =
  'Scoot does not support iOS Safari. To join Scoot from your iOS device, please click Get iOS App below to download the Scoot iOS app and join your room.';
export const IOS_APP_URL = 'https://apps.apple.com/us/app/scoot-app/id1568145097';

export const BRANCH_IO_IOS_APP_URL = 'https://preciate-dev.test-app.link/scoot-room';

// #region Screen Share
export const SCREEN_SHARE_NO_MEDIA = 'No appropriate screens are available to share.';
export const SCREEN_SHARE_NOT_SUPPORTED = 'Screen sharing is not supported on your browser.';
export const SCREEN_SHARE_RESOURCE_DENIED = 'The screen share request was denied or cancelled.';
export const SCREEN_SHARE_RESOURCE_NOT_PERMITTED = 'The screen share request was not permitted by the system.';
export const SCREEN_SHARE_SECURITY_ERROR = 'The screen share request was denied by a security policy.';
export const SCREEN_SHARE_SECURITY_ERROR_PERMISSIONS_POLICY =
  'The screen share request was denied by permissions policy.';
export const SCREEN_SHARE_UNKNOWN_ERROR = 'An error occurred while sharing your screen.';
// #endregion

export const SOCIAL_LICENSE_REQUIRED = 'does not have a license required';
export const SOCIAL_LICENSE_EXCEEDED = 'exceeds license limit';

// #region Presentation
export const RECORDING_START_FAILED_ERROR = 'Failed to start a recording. Please contact support.';
export const RECORDING_STOP_FAILED_ERROR = 'Failed to end the recording. Please contact support.';
// #endregion

// #region Group Share
export const GROUP_SHARE_RECORDING_START_FAILED_ERROR =
  'Failed to start a group share recording. Please contact support.';
export const GROUP_SHARE_RECORDING_STOP_FAILED_ERROR =
  'Failed to end the group share recording. Please contact support.';
// #endregion

// #region Guest sign in
export const GUEST_SIGN_IN_ERROR =
  'There was an error signing in as a guest. Please try again. If this persists, please contact support at support@scoot.com.';
// #endregion

// #region Waiting room

export const CAMERA_UNREADABLE_TITLE = 'Selected camera is unavailable';
export const CAMERA_UNREADABLE_TEXT =
  'Your camera is not working, and may be in use by another application. You may still join the room without video.';
export const CAMERA_UNREADABLE_TEXT_IN_ROOM =
  'Your camera is not working, and may be in use by another application. Your video has been disabled.';
export const CAMERA_UNREADABLE_HELP_TEXT = 'How do I troubleshoot my camera?';

// #endregion

// #region Photobooth
export const PHOTO_BOOTH_DOWNLOAD_FAILED_TITLE = 'Failed to download photos';
export const PHOTO_BOOTH_DOWNLOAD_FAILED_TEXT = 'Downloading photos failed. Please contact support.';
// #endregion
